import store, { persistor, persistKey } from './index';
import { signOut } from './user';
import { reset as resetStudent } from './student';
import { resetPatient } from './patient';
import { resetSurvey } from './survey';
import {
  isTokenExpired,
  setAuthTokenReader,
  setUnauthorizedHandler,
} from 'apis/authToken';

/** 로그인 상태를 비워 로그인 화면으로 보낸다. 로그아웃 메뉴와 같은 정리를 한다 */
const signOutForAuth = () => {
  if (!store.getState().user.student_uuid) return;
  store.dispatch(signOut());
  store.dispatch(resetStudent());
  store.dispatch(resetPatient());
  store.dispatch(resetSurvey());
  localStorage.removeItem(`persist:${persistKey}`);
};

/** 토큰 없이 남은 로그인(이 배포 전 로그인)이나 만료된 토큰이면 다시 로그인하게 한다 */
const checkStoredSession = () => {
  const { student_uuid, token, token_received_at } = store.getState().user;
  if (student_uuid && (!token || isTokenExpired(token, token_received_at)))
    signOutForAuth();
};

/** ENR-BUGFIX-127 — 요청마다 토큰을 붙이고 401 이면 로그인 화면으로 보낸다 */
export function startAuthSession() {
  setAuthTokenReader(() => store.getState().user.token);
  setUnauthorizedHandler(signOutForAuth);

  if (persistor.getState().bootstrapped) {
    checkStoredSession();
    return;
  }
  const unsubscribe = persistor.subscribe(() => {
    if (!persistor.getState().bootstrapped) return;
    unsubscribe();
    checkStoredSession();
  });
}
